<template lang="pug">
.container-landingpage
  span(class="background-animation left")
  span(class="background-animation right")
  span(class="background-animation bottom")
  SejaVisto
  .container-visao-inovacao
    VisaoInovacao
  .container-nossos-pilares
    NossosPilares
  .container-footer
    Footer
</template>

<script>
import SejaVisto from '@/components/landingPage/SejaVisto.vue';
import VisaoInovacao from '@/components/landingPage/VisaoInovacao.vue';
import NossosPilares from '@/components/landingPage/NossosPilares.vue';
import Footer from '@/components/landingPage/Footer.vue';
export default {
  components: {
    SejaVisto,
    VisaoInovacao,
    NossosPilares,
    Footer
  }
}
</script>

<style lang="scss" scoped>
.container-landingpage {
  font-family: "Inter", sans-serif !important;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  z-index: 0;

  &::before{
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.3;
    background-image: linear-gradient(rgba(109, 215, 8, .1) 1px, transparent 1px), linear-gradient(90deg, rgba(109, 215, 8, .1) 1px, transparent 1px);
    background-size: 40px 40px;
    z-index: -1;
  }
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: 
      linear-gradient(45deg, transparent, rgba(109, 215, 8, 0.1), transparent),
      linear-gradient(to right, rgba(109, 215, 8, 0.05), transparent),
      linear-gradient(to bottom right, transparent, rgba(109, 215, 8, 0.08));
    opacity: 0.3;
    z-index: -1;
  }

  .background-animation {
    position: fixed;
    width: 100%;
    height: 100%;
    animation: 6s ease-in-out 0s infinite normal none running float;
    z-index: 0;

    &.left {
      left: 2%;
      top: 9%;
      background: rgba(109, 215, 8, 0.1);
      width: 80px;
      height: 80px;
      animation-delay: 0s;
    }
    &.right {
      right: 5%;
      top: 18%;
      background: rgba(109, 215, 8, 0.15);
      width: 64px;
      height: 64px;
      animation-delay: 2s;
    }
    &.bottom {
      right: 34%;
      bottom: 8%;
      background: rgba(109, 215, 8, 0.2);
      width: 48px;
      height: 48px;
      animation-delay: 4s;
    }
  }

  .container-visao-inovacao,
  .container-nossos-pilares {
    width: 100%;
    padding: 0 24px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .container-nossos-pilares{
    padding: 0;
  }
  .container-footer {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #6dd70833;
    padding: 64px 0;
  }

  @keyframes float {
    0%, 100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-10px);
    }
  }
}
</style>